export enum ScanType {
  LH_PG = 'LH_PG',
  LR_E3G = 'LR_E3G',
}
